import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  selectProductsTitle: {
    defaultMessage: '{index}Select Products',
    id: '2nt9mt',
    description: 'Title of the select products step',
  },
  addProductsToBeShippedDescription: {
    defaultMessage: 'Add the products to be included in the shipment.',
    id: 'UfpgF5',
    description: 'Description of the select products step',
  },
  productsAddedCount: {
    defaultMessage: '{count, plural, one {# Product added} other {# Products added}}',
    id: '126M34',
    description: 'Count of products added to the select products table.',
  },
  readOnlyProductCount: {
    defaultMessage: 'Total Products: {productCount}',
    id: 'JVmoXH',
    description: 'Read only product count',
  },
  barcodeErrorHeader: {
    defaultMessage: 'Some products are missing barcodes.',
    description: 'Header of banner error to inform user products are missing barcodes',
    id: 'hjqn5n',
  },
  barcodeErrorBody: {
    defaultMessage:
      'One or more products require an associated barcode to proceed. You may add barcodes to a product by clicking on the linked SKU for the item in the table below and adding the barcode to the product details.',
    description: 'Body of banner error to inform user products are missing barcodes',
    id: '69ttx4',
  },
  addProductsCsvImportButton: {
    defaultMessage: 'Import via CSV',
    id: 'Fd7wD2',
    description: 'Button to add products via CSV import',
  },
});
